/**
 * Balance-refresh signal (decoupled).
 *
 * AuthContext sits ABOVE the BalanceProvider in the React tree, so it cannot
 * call useBalances()/refreshBalances() directly. After a registration flow
 * completes (the 10k Gold Coin signup grant is applied atomically server-side)
 * the granted balance won't show until a manual reload: the initial fetch may
 * run before the players row is ready, and the realtime subscription never
 * fires for a balance that already existed at subscribe time.
 *
 * To bridge that without a provider-ordering change, AuthContext dispatches
 * this window event; useBalances listens for it and refetches (with one retry).
 * Kept in its own module so both AuthContext and useBalances can import the
 * constant without creating a circular dependency (useBalances imports useAuth
 * from AuthContext).
 */
export const BALANCES_REFRESH_EVENT = "cluck:balances:refresh";

/**
 * Fire-and-forget request for any mounted useBalances instance to refetch.
 * Safe to call anywhere (guards SSR / non-browser and never throws).
 */
export function requestBalanceRefresh() {
  if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") {
    return;
  }
  try {
    window.dispatchEvent(new CustomEvent(BALANCES_REFRESH_EVENT));
  } catch {
    // Best-effort only; a failed dispatch must never break the auth flow.
  }
}
